import { createReducer, createAction } from "redux-act";
import * as app from "./app";

const SAVE_PROGRAM_FORM_REQUEST = `${app.NS}account/save_program_form_request`;
export const SAVE_PROGRAM_FORM_REQUEST_ACTION = createAction(
  SAVE_PROGRAM_FORM_REQUEST
);
const SAVE_PROGRAM_FORM_SUCCESS = `${app.NS}account/save_program_form_success`;
export const SAVE_PROGRAM_FORM_SUCCESS_ACTION = createAction(
  SAVE_PROGRAM_FORM_SUCCESS
);
const SAVE_PROGRAM_FORM_FAILURE = `${app.NS}account/save_program_form_failure`;
export const SAVE_PROGRAM_FORM_FAILURE_ACTION = createAction(
  SAVE_PROGRAM_FORM_FAILURE
);

export const saveProgramFormRequest = id => {
  const action = SAVE_PROGRAM_FORM_REQUEST_ACTION(id);
  return action;
};
export const saveProgramFormSuccess = user => {
  const action = SAVE_PROGRAM_FORM_SUCCESS_ACTION(user);
  return action;
};

export const saveProgramFormFailure = error => {
  const action = SAVE_PROGRAM_FORM_FAILURE_ACTION(error);
  return action;
};



// WEBPACK FOOTER //
// ./src/ducks/program.js